import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetInProgressSmartInstallmentCyclesOutput } from '../domain/dtos/get-in-progress-smart-installment-cycles'
import { Envs } from '../envs'

export class GetInProgressSmartInstallmentCycles {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) { }

  public async execute(): Promise<GetInProgressSmartInstallmentCyclesOutput | undefined> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_MEMBER_PORTAL_URL}/smart-installment-cycles/in-progress`,
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new Error('Não foi possível buscar os parcelamentos em progresso')
  }
}
